import facebookCTA from './facebookCTA.svg'
import facebookFooter from './facebookFooter.svg'
import twitterCTA from './twitterCTA.svg'
import twitterFooter from './twitterFooter.svg'
import youtubeCTA from './youtubeCTA.svg'
import youtubeFooter from './youtubeFooter.svg'

export const socialMediasConfig = [
  {
    name: 'twitter',
    srcCTA: twitterCTA,
    srcFooter: twitterFooter,
    gaLabel: 'twitter account',
  },
  {
    name: 'facebook',
    srcCTA: facebookCTA,
    srcFooter: facebookFooter,
    gaLabel: 'facebook page',
  },
  {
    name: 'youtube',
    srcCTA: youtubeCTA,
    srcFooter: youtubeFooter,
    gaLabel: 'youtube channel',
  },
]
